import dayjs from 'dayjs';
import { ReportPeriod } from '../../customer-shared/models/ReportPeriod';

export function formattedReportDate(date: any, period: ReportPeriod): string {
  return dayjs(date).format(period === ReportPeriod.Daily ? '[Daily:] dddd, MMM D' : '[Monthly:] MMMM, YYYY');
}
